import React, { useEffect, useMemo, useState } from "react";
import Icon from "@mdi/react";
import { mdiClose, mdiMinus, mdiPlus, mdiCartCheck } from "@mdi/js";

import { getBranch, getUserLogin } from "utils/utils";
import { pushNotification } from "utils/notifications";
import DatHangDaiLyApi from "../../service/datHangDaiLyApi";
import DatHangApi from "../../service/DatHang/DatHangApi";
import momentLocalizer from "react-widgets-moment";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
momentLocalizer(moment);

const DEFAULT_PRODUCT_IMAGE =
  "data:image/svg+xml;charset=UTF-8,%3Csvg width='220' height='220' viewBox='0 0 220 220' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='220' height='220' rx='12' fill='%23f1f5f9'/%3E%3Cpath d='M62 155h96V75H62v80zm10-70h76v60H72V85z' fill='%23cbd5e1'/%3E%3Ccircle cx='92' cy='105' r='10' fill='%23e2e8f0'/%3E%3Cpath d='M75 140l28-28 18 18 12-12 17 22H75z' fill='%23e2e8f0'/%3E%3Ctext x='110' y='180' text-anchor='middle' font-size='14' font-family='Arial' fill='%2394a3b8'%3ENo image%3C/text%3E%3C/svg%3E";

export default function GioHang({ cartItems, setCartItems, onOrderSuccess }) {
  const initData = {
    OrderDatHangID: 0,
    OrderCode: "",
    CreatedTime: new Date(),
    UpdatedTime: new Date(),
    CreatedUser: getUserLogin().UserName,
    UpdatedUser: "",
    Note: "",
    CustomerID: 0,
    CustomerName: "",
    CustomerAddress: "",
    Phone: "",
    AccountBank: "",
    TaxCode: "",
    TotalAmount: 0,
    TotalPaid: 0,
    TotalPaidOlder: 0,
    StoreExportStatus: 1,
    IsAddTax: true,
    DatePaid: new Date(),
    OtherFee: 0,
    CustomerDebt: 0,
    ChietKhau: 0,
    GiaoHang: true,
    Approval: 0,
    BankId: 0,
    TypeMoney: 0,
    NgayTao: new Date(),
    NgayCapNhat: new Date(),
    BranchID: 0,
    ChietKhau_CongThuc: "",
    IsAutoTruKho: false,
    TrangThaiGiaoNhan: 0,
    NgayDuKienGiao: new Date(new Date().getTime() + 1 * 60000),
    IsDuHang: true,
    TotalAmountThueGTGT: 0,
    IsLayHoaDon: false,
    ThueGTGT: 0,
    HanThanhToan: null,
    POCode: "",
    lstChiTiet: [],
    NVKD: "",
    NVKDID: 0,
    BranchName: "",
    IsDoiTac: true,
    isShowThueGTGT: false,
    isRoleGiaoNhan: null,
    TotalAmountNew: 0,
    SoNgayNo: 0,
    sUserName: getUserLogin().UserName,
    isShowGiaVon: false,
    BankName: "Tiền mặt",
    ConfigSuaNgay: null,
    ConfigPhienBan: null,
    ConfigThueGTGT: null,
    ConfigCanhBaoDHQuaHan: null,
    ConfigMaPO: null,
    ConfigNhanVienKinhDoanh: null,
    ConfigChuaGiCong: null,
    ConfigTruKhoGiaCong: null,
    configThuocTinhKhac: "0",
    ConfigBanBuonBanLe: null,
    ConfigTiTrong: null,
    configChietKhau: null,
    configDateChiTietDH: null,
    ConfigBanAm: null,
    ConfigTruKhoVaoNgayTao: null,
    ConfigSuaSanPhamBanHang: null,
    ConfigShowTTKTheoNhom: null,
    ConfigMauHoaDon: "",
    ConfigThanhToanDHCu: null,
    ConfigLamTronTien: null,
    ConfigCongThucCK: null,
    ConfigPhanBoCongNoTheoSanPham: null,
    ChietKhau_NhomSP: 0,
    DiaChiGiaoHang: "",
    ListAddress: [],
    TinhThanhPho: 0,
    QuanHuyen: 0,
    XaPhuong: 0,
    lstDinhKhoan: [],
    lstLoaiPBCNQuaHan: [],
  };

  const [dataBanHang, setDataBanHang] = useState(initData);
  const [selectedIds, setSelectedIds] = useState([]);
  const [note, setNote] = useState("");
  const [expectedDate, setExpectedDate] = useState(new Date());
  const [isSaving, setIsSaving] = useState(false);

  // useEffect(() => {
  //   loadGioHang();
  // }, []);
  useEffect(() => {
    loadThongTinKhachHang();
  }, []);

  // const loadGioHang = () => {
  //   DatHangDaiLyApi.listThongTinGioHang(getUserLogin().UserName)
  //     .then((response) => {
  //       console.log(response, "gio hang");
  //       if (response.status === 200) {
  //         if (response?.data) {
  //           setCartItems(JSON.parse(response.data || "[]"));
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Lỗi load giỏ hàng", err);
  //     });
  // };

  const loadThongTinKhachHang = () => {
    DatHangApi.getChiTietKhachHangById(getUserLogin().UserName)
      .then((response) => {
        if (response.status === 200) {
          setDataBanHang((prev) => ({
            ...prev,
            CustomerID: response.data.CustomerID,
            CustomerName: response.data.CustomerName,
            CustomerAddress: response.data.CustormerAddress,
            HanThanhToan: null,
            Phone: response.data.Phone,
            NVKD: response.data.NVKDUserName,
            NVKDID: response.data.NVKDID,
            CustomerDebt: response.data.Debt * -1,
            TaxCode: response.data.TaxCode,
            SoNgayNo: response.data.SoNgayNo,
            DiaChiGiaoHang: response.data.DiaChiGiaoHang,
            ListAddress: response.data.ListAddress,
          }));
        }
      })
      .catch((err) => {
        console.log("Lỗi lấy thông tin khách hàng", err);
      });
  };

  const getCartKey = (item) => `${item.CategoryID}_${item.OptionID || 0}`;

  const isCheckedAll = useMemo(() => {
    return cartItems.length > 0 && selectedIds.length === cartItems.length;
  }, [cartItems, selectedIds]);

  const selectedItems = useMemo(() => {
    return cartItems.filter((item) => selectedIds.includes(getCartKey(item)));
  }, [cartItems, selectedIds]);

  const totalSelectedQty1 = useMemo(() => {
    return selectedItems.reduce(
      (total, item) => total + Number(item.SoLuongMua || 0),
      0,
    );
  }, [selectedItems]);
  const totalSelectedQty = useMemo(() => {
    return selectedItems.length;
  }, [selectedItems]);

  const totalMoney = useMemo(() => {
    return selectedItems.reduce((total, item) => {
      const price = Number(item.CategoryPrice || 0);
      if (price <= 0) return total;
      return total + price * Number(item.SoLuongMua || 0);
    }, 0);
  }, [selectedItems]);

  const toggleCheckAll = (checked) => {
    setSelectedIds(checked ? cartItems.map((item) => getCartKey(item)) : []);
  };

  const toggleCheckItem = (id, checked) => {
    if (checked) {
      setSelectedIds((prev) => [...new Set([...prev, id])]);
    } else {
      setSelectedIds((prev) => prev.filter((x) => x !== id));
    }
  };

  const updateQty = (id, value) => {
    const onlyNumber = value.toString().replace(/[^0-9.]/g, "");

    setCartItems(
      cartItems.map((item) =>
        getCartKey(item) === id
          ? {
              ...item,
              SoLuongMua: onlyNumber,
            }
          : item,
      ),
    );
  };

  const blurQty = (id) => {
    const newCart = cartItems.map((item) =>
      getCartKey(item) === id
        ? {
            ...item,
            SoLuongMua:
              Number(item.SoLuongMua || 0) <= 0
                ? 1
                : Number(item.SoLuongMua || 0),
          }
        : item,
    );

    setCartItems(newCart);

    DatHangDaiLyApi.addGioHang({
      UserName: getUserLogin().UserName,
      GioHangNoiDung: JSON.stringify(newCart),
    });
  };
  const blurQty111 = (id) => {
    setCartItems(
      cartItems.map((item) =>
        getCartKey(item) === id
          ? {
              ...item,
              SoLuongMua:
                Number(item.SoLuongMua || 0) <= 0
                  ? 1
                  : Number(item.SoLuongMua || 0),
            }
          : item,
      ),
    );
  };

  const increaseQty = (id) => {
    const newCart = cartItems.map((item) =>
      getCartKey(item) === id
        ? {
            ...item,
            SoLuongMua: Number(item.SoLuongMua || 0) + 1,
          }
        : item,
    );

    setCartItems(newCart);

    DatHangDaiLyApi.addGioHang({
      UserName: getUserLogin().UserName,
      GioHangNoiDung: JSON.stringify(newCart),
    });
  };

  const increaseQty111 = (id) => {
    setCartItems(
      cartItems.map((item) =>
        getCartKey(item) === id
          ? {
              ...item,
              SoLuongMua: Number(item.SoLuongMua || 0) + 1,
            }
          : item,
      ),
    );
  };

  const decreaseQty = (id) => {
    const currentItem = cartItems.find((item) => getCartKey(item) === id);

    if (!currentItem) return;

    if (Number(currentItem.SoLuongMua || 0) <= 1) {
      removeItem(id);
      return;
    }

    const newCart = cartItems.map((item) =>
      getCartKey(item) === id
        ? {
            ...item,
            SoLuongMua: Number(item.SoLuongMua || 0) - 1,
          }
        : item,
    );

    setCartItems(newCart);

    DatHangDaiLyApi.addGioHang({
      UserName: getUserLogin().UserName,
      GioHangNoiDung: JSON.stringify(newCart),
    });
  };

  const decreaseQty111 = (id) => {
    const currentItem = cartItems.find((item) => getCartKey(item) === id);
    if (!currentItem) return;

    if (Number(currentItem.SoLuongMua || 0) <= 1) {
      removeItem(id);
      return;
    }

    setCartItems(
      cartItems.map((item) =>
        getCartKey(item) === id
          ? {
              ...item,
              SoLuongMua: Number(item.SoLuongMua || 0) - 1,
            }
          : item,
      ),
    );
  };

  const removeItem1111 = (id) => {
    setCartItems(cartItems.filter((item) => getCartKey(item) !== id));
    setSelectedIds((prev) => prev.filter((x) => x !== id));
  };

  const removeItem = (id) => {
    const newCart = cartItems.filter((item) => getCartKey(item) !== id);

    setCartItems(newCart);

    setSelectedIds((prev) => prev.filter((x) => x !== id));

    DatHangDaiLyApi.addGioHang({
      UserName: getUserLogin().UserName,
      GioHangNoiDung: JSON.stringify(newCart),
    });
  };

  const submitOrder = () => {
    if (isSaving) return;

    if (selectedIds.length === 0) {
      pushNotification(
        "Vui lòng chọn sản phẩm đặt hàng",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    const activeCartItems = cartItems.filter((item) => item.isActive !== false);
    const removedItems = cartItems.filter((item) => item.isActive === false);

    if (removedItems.length > 0) {
      setCartItems(activeCartItems);
      setSelectedIds((prev) =>
        prev.filter((id) =>
          activeCartItems.some((item) => getCartKey(item) === id),
        ),
      );

      pushNotification(
        "Một số sản phẩm đã bị khóa/xóa trên link PM nên đã được xóa khỏi giỏ hàng. Vui lòng kiểm tra lại giỏ hàng.",
        "error",
        "TOP_RIGHT",
        3000,
      );
      return;
    }

    const selectedActiveItems = activeCartItems.filter((item) =>
      selectedIds.includes(getCartKey(item)),
    );

    if (selectedActiveItems.length === 0) {
      pushNotification(
        "Vui lòng chọn sản phẩm đặt hàng",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    if (Number(getBranch() || 0) === 0) {
      pushNotification(
        "Chưa xác nhận được chi nhánh đặt hàng. Vui lòng chọn lại chi nhánh",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    if (Number(dataBanHang.CustomerID || 0) === 0) {
      pushNotification(
        "Chưa xác nhận được thông tin đại lý. Vui lòng tải lại trang",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    const lstChiTiet = selectedActiveItems.map((item) => ({
      ...item,
      SoLuongMua: Number(item.SoLuongMua || 0),
      CategoryPrice: Number(item.CategoryPrice || 0),
      SaleTime: item.SaleTime
        ? moment(item.SaleTime).format("YYYY-MM-DD HH:mm:ss")
        : moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      Quantity: 1,
      ValueOfUnitForExportPrice: Number(item.SoLuongMua || 0),
    }));

    const payload = {
      ...dataBanHang,
      BranchID: getBranch(),
      Note: note,
      NgayDuKienGiao: moment(expectedDate).format("YYYY-MM-DD HH:mm:ss"),
      CreatedTime: moment(dataBanHang.CreatedTime).format(
        "YYYY-MM-DD HH:mm:ss",
      ),
      HanThanhToan: dataBanHang.HanThanhToan
        ? moment(dataBanHang.HanThanhToan).format("YYYY-MM-DD HH:mm:ss")
        : null,
      TotalAmount: totalMoney,
      TotalAmountNew: 0,
      TotalAmountThueGTGT: 0,
      lstChiTiet: lstChiTiet,
      sUserName: getUserLogin().UserName,
    };

    setIsSaving(true);

    DatHangDaiLyApi.addOrUpdateDatHang(payload)
      .then((response) => {
        setIsSaving(false);

        if (response.status === 200) {
          pushNotification(
            "Gửi thông tin yêu cầu đặt hàng thành công",
            "success",
            "TOP_RIGHT",
            2000,
          );

          setCartItems(
            activeCartItems.filter(
              (item) => !selectedIds.includes(getCartKey(item)),
            ),
          );
          setSelectedIds([]);
          setNote("");

          if (onOrderSuccess) {
            onOrderSuccess();
          }
        } else if (response.status === 500) {
          pushNotification(response.data, "error", "TOP_RIGHT", 4000);
        } else {
          pushNotification(
            response.data || "Có lỗi xảy ra khi đặt hàng",
            "error",
            "TOP_RIGHT",
            4000,
          );
        }
      })
      .catch((err) => {
        setIsSaving(false);
        console.log("Lỗi đặt hàng", err);
        pushNotification(
          "Có lỗi xảy ra khi đặt hàng",
          "error",
          "TOP_RIGHT",
          4000,
        );
      });
  };

  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="cart-shop-page">
      <h2 className="cart-shop-title">Giỏ hàng</h2>

      {cartItems.length === 0 ? (
        <div className="cart-shop-empty">Chưa có sản phẩm trong giỏ hàng.</div>
      ) : (
        <div className="cart-shop-layout">
          <div className="cart-shop-left">
            <div className="cart-shop-select-all">
              <label>
                <input
                  type="checkbox"
                  checked={isCheckedAll}
                  onChange={(e) => toggleCheckAll(e.target.checked)}
                />
                <span>Chọn tất cả</span>
              </label>
            </div>

            <div className="cart-shop-list">
              {cartItems.map((item) => {
                const cartKey = getCartKey(item);

                return (
                  <div className="cart-shop-item" key={cartKey}>
                    <div className="cart-shop-check-cell">
                      <input
                        className="cart-shop-checkbox"
                        type="checkbox"
                        checked={selectedIds.includes(cartKey)}
                        onChange={(e) =>
                          toggleCheckItem(cartKey, e.target.checked)
                        }
                      />
                    </div>

                    <img
                      className="cart-shop-image"
                      src={item.CategoryImage || DEFAULT_PRODUCT_IMAGE}
                      alt={item.CategoryName}
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                      }}
                    />

                    <div className="cart-shop-info">
                      <div className="cart-shop-name">{item.CategoryName}</div>

                      <div className="cart-shop-desc">
                        {item.IsMuaGiaCong && item.OptionName
                          ? `Kiểu gia công: ${item.OptionName}`
                          : ""}
                      </div>
                    </div>

                    <div className="cart-shop-price">
                      {Number(item.CategoryPrice || 0) > 0
                        ? `${Number(item.CategoryPrice).toLocaleString()}đ`
                        : "Liên hệ"}
                    </div>

                    <div className="cart-shop-qty">
                      <button
                        type="button"
                        onClick={() => decreaseQty(cartKey)}
                      >
                        <Icon path={mdiMinus} size={0.65} />
                      </button>

                      <input
                        value={item.SoLuongMua}
                        onChange={(e) => updateQty(cartKey, e.target.value)}
                        onBlur={() => blurQty(cartKey)}
                        style={{ textAlign: "center" }}
                      />

                      <button
                        type="button"
                        onClick={() => increaseQty(cartKey)}
                      >
                        <Icon path={mdiPlus} size={0.65} />
                      </button>

                      {item.TenDonViXuat && (
                        <span style={{ marginLeft: "6px" }}>
                          {item.TenDonViXuat}
                        </span>
                      )}
                    </div>

                    <button
                      type="button"
                      className="cart-shop-remove"
                      onClick={() => removeItem(cartKey)}
                      title="Xóa"
                    >
                      <Icon path={mdiClose} size={0.75} />
                    </button>
                  </div>
                );
              })}
            </div>

            <div className="cart-shop-note">
              <label>Ghi chú đơn hàng</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                rows={3}
              />
            </div>
          </div>

          <div className="cart-shop-summary">
            <div className="cart-summary-row total">
              <span>TỔNG CỘNG</span>
              <b>{totalMoney.toLocaleString()}đ</b>
            </div>

            <div className="cart-summary-note">
              (Tổng tiền không bao gồm sản phẩm có giá liên hệ)
            </div>

            <div className="cart-summary-line" />

            <div className="cart-date-row">
              <label>Thời gian nhận hàng dự kiến</label>

              <DateTimePicker
                value={expectedDate}
                onChange={(value) => setExpectedDate(value)}
                min={new Date()}
                format={"DD/MM/YYYY HH:mm:ss"}
                time={false}
                culture="vi"
                open={isOpen}
                onFocus={() => setIsOpen("date")}
                onBlur={() => setIsOpen(false)}
                onSelect={() => setIsOpen(false)}
              />
            </div>

            <div className="cart-total-product">
              Tổng sản phẩm đã chọn: <b>{totalSelectedQty}</b>
            </div>
            <div className="cart-total-product">
              Số lượng mua: <b>{totalSelectedQty1}</b>
            </div>

            <button
              className="cart-payment-btn"
              onClick={submitOrder}
              disabled={isSaving}
            >
              <Icon path={mdiCartCheck} size={0.95} />
              {isSaving ? "Đang đặt hàng..." : "Đặt hàng"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
